import { useState } from 'react'
import { message } from 'antd'
import type { FormInstance } from 'antd'
import type { ConfigType, ConfigField } from '../utils/configTypes'

export function useConfigInlineEdit(
  form: FormInstance,
  configType: ConfigType,
  field: ConfigField,
  onFormChange?: () => void
) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [tempValue, setTempValue] = useState<number | null>(null)

  const handleToggle = (checked: boolean) => {
    if (!checked) {
      // Clear the threshold value when toggling off
      form.setFieldValue([configType, field.key, 'threshold'], null)
      form.setFieldValue([configType, field.key, 'enabled'], false)
      onFormChange?.()
    } else if (field.unit) {
      // Store current value (if any) and open popover
      const currentValue = form.getFieldValue([configType, field.key, 'threshold'])
      setTempValue(currentValue)
      setIsPopoverOpen(true)
    } else {
      form.setFieldValue([configType, field.key, 'enabled'], true)
      onFormChange?.()
    }
  }

  const handleCancel = () => {
    // Restore the previous state
    setIsPopoverOpen(false)
    // If there was no previous value, turn the switch off
    if (tempValue === null) {
      form.setFieldValue([configType, field.key, 'enabled'], false)
    }
    // Restore the previous threshold value
    form.setFieldValue([configType, field.key, 'threshold'], tempValue)
    setTempValue(null)
  }

  const handleApply = () => {
    form
      .validateFields([[configType, field.key, 'threshold']])
      .then(() => {
        setIsLoading(true)
        onFormChange?.()
        setIsPopoverOpen(false)
        setIsLoading(false)
        setTempValue(null)
      })
      .catch((errorInfo) => {
        console.error('Validation failed:', errorInfo)
        message.error('Please fix validation errors before applying')
      })
  }

  return {
    isPopoverOpen,
    setIsPopoverOpen,
    isLoading,
    tempValue,
    handleToggle,
    handleCancel,
    handleApply,
  }
}
